"use strict";

import Vue from 'vue';
import axios from "axios";
import process from '../config/env.example.js'
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
const token='eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvcXl0YW5leHRhcGkudGVzdFwvY2hlY2tsaXN0LWFwaVwvbG9naW4iLCJpYXQiOjE1NDkxOTkyNDEsImV4cCI6MTU1MTc5MTI0MSwibmJmIjoxNTQ5MTk5MjQxLCJqdGkiOiJxb2V0dHl4VzQ0ZnJSeFBsIiwic3ViIjoiMTYwNDUzNTMiLCJwcnYiOiI4OTlmOGRmYjQzOWMxMDUyNmVhYzU1YThmM2I4OGMxNjVmMGNmNmQ0In0.gKPjwJkBUesgJT5spB-tIzjMZeviWryZyxICmm89AfY';

let config = {
  baseURL: process.server,
  // timeout: 60 * 1000, // Timeout
  //withCredentials: true, // Check cross-site Access-Control
  //headers: {Content-Type: 'application/json'}
};
//_axios.headers.common[`Authorization`]`Bearer ${token}`
const _axios = axios.create(config);
_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
